import { Component, inject } from '@angular/core'

import { PivotRecord } from '@cyborg-monorepo/hunter/common'
import {
  BaseDialogComponent,
  ReusableDialogComponent,
  CodeBlockComponent,
} from '@hyperkit'

import { QueryViewService } from '../../../../../../services/reader/query-view.service'

@Component({
  standalone: true,
  selector: 'original-query-component',
  templateUrl: './original-query-dialog.component.html',
  styleUrls: ['./original-query-dialog.component.scss'],
  imports: [ReusableDialogComponent, CodeBlockComponent],
})
export class OriginalQueryComponent extends BaseDialogComponent<void> {
  private readonly queryView = inject(QueryViewService)

  /** Retrieve the original query text */
  public originalQuery = () => this.queryView.originalQuery()

  protected override initializeOptions(): void {
    this.options = {
      headerText: 'View Original Query',
      primaryButtonText: 'Close',
    }
  }

  public onSubmit(): void {
    this.onPrimaryAction()
  }

  public trackById = (_: number, item: PivotRecord) => item.UUID
}
